import React from 'react';
import {
  FieldInputProps,
  FieldMetaProps,
} from '../../Constants/ReduxFormPropTypes';

const handleFocus = (event) => event.target.select();

const ProviderName = ({ input, meta }) => (
  <input
    {...input}
    className={`form-control form-control-lg col-sm-6 mr-3 ${
      meta.touched && meta.error ? 'border-danger' : ''
    }`}
    aria-label="Provider"
    onFocus={handleFocus}
  />
);

ProviderName.propTypes = {
  input: FieldInputProps.isRequired,
  meta: FieldMetaProps.isRequired,
};

export default ProviderName;
